import * as types from "./alvara.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  Id: undefined,
  IdObraProjeto: undefined,
  Protocolo: undefined,
  Processo: undefined,
  Projeto: undefined,
  DataInicio: undefined,
  Solicitante: undefined,
  ResponsavelProjeto: undefined,
  ARTResponsavelProjeto: undefined,
  ResponsavelExecucao: undefined,
  ARTResponsavelExecucao: undefined,
  DataVencimento: undefined,
  Numero: undefined,
  Situacao: undefined,
  Proprietario: undefined,
  Endereco: {},
  DataEmissaoAlvara: undefined,
  NumeroProjeto: undefined,
  AnoProjeto: undefined
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.ALVARA_SET:
      return state.merge(payload);
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("tributario.obrasParticulares.alvara", reduce);
